import React from "react";
import { styled } from "@mui/material/styles";
import { InternalStandardProps, Box, GridProps } from "@mui/material";
import { Event } from "JS/Models/Events";
import moment from "moment";
import { AppTypography } from "./AppTypography";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppDivider } from "./AppDivider";

const RootBox = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: "90px",
});

const ListTitleBox = styled(Box)({
    width: "80%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
});

const ListIconsWrapper = styled(Box)({
    width: "10%",
});

const ForwardIcon = styled(FontAwesomeIcon)(({ theme }) => ({
    color: theme.palette.common.black,
}));

const EventItemTitle = styled(AppTypography)(({ theme }) => ({
    width: "100%",
    color: theme.palette.primary.main,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
}));

const EventItemCaption = styled(AppTypography)(({ theme }) => ({
    color: theme.palette.common.black,
}));

export interface EventItemProps extends InternalStandardProps<GridProps> {
    event: Event;
    onEventItemClick: (
        e: React.MouseEvent<HTMLDivElement, MouseEvent>,
        eventName: string,
    ) => void;
}

export const EventItem = (props: EventItemProps) => {
    const { className, event, onEventItemClick } = props;
    return (
        <>
            <RootBox
                data-testid="root"
                className={className}
                onClick={(e) => onEventItemClick(e, event?.EventName)}
            >
                <ListTitleBox>
                    <EventItemTitle variant="body1">
                        {event?.EventName}
                    </EventItemTitle>
                    <EventItemCaption variant="caption">
                        {moment(
                            event?.EventStartDateAndTime.split("T")[0],
                        ).format("LL") +
                            " to " +
                            moment(
                                event?.EventEndDateAndTime.split("T")[0],
                            ).format("LL")}
                    </EventItemCaption>
                </ListTitleBox>
                <ListIconsWrapper>
                    <ForwardIcon icon={["fas", "chevron-right"]} />
                </ListIconsWrapper>
            </RootBox>
            <AppDivider />
        </>
    );
};
